import React, { useState, useEffect } from 'react';
import {
    Box, Button, Stack, Paper, FormControl, OutlinedInput,
    Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography
} from '@mui/material';
import { Close as CloseIcon, Edit as EditIcon } from '@mui/icons-material';
import { toast } from "react-hot-toast";
import DataGridComponent from '../../components/DataGridComponent';
import { useDispatch, useSelector } from 'react-redux';
import { getCrownsListApi } from '../../store/crowns-and-badges/getCrownsList';
import { updateCrownPointsApi, resetUpdateCrownPoints } from '../../store/crowns-and-badges/updateCrownPoints';

export default function Crowns() {
    const dispatch = useDispatch();
    const { result, loading } = useSelector((state) => state.getCrownsList);
    const { loading: updateLoading } = useSelector((state) => state.updateCrownPoints);
    const [crowns, setCrowns] = useState([]);

    // Modal state
    const [open, setOpen] = useState(false);
    const [selectedCrown, setSelectedCrown] = useState(null);
    const [tempValue, setTempValue] = useState('');

    useEffect(() => {
        if (result) {
            const formattedCrowns = [
                { id: 'level_1_points', name: '1 Star', points: result.level_1_points },
                { id: 'level_2_points', name: '2 Stars', points: result.level_2_points },
                { id: 'level_3_points', name: '3 Stars', points: result.level_3_points },
                { id: 'level_4_points', name: '4 Stars', points: result.level_4_points },
                { id: 'level_5_points', name: '5 Stars', points: result.level_5_points },
            ];
            setCrowns(formattedCrowns);
        }
    }, [result]);

    const handleEditClick = (crown) => {
        setSelectedCrown(crown);
        setTempValue(crown.points || '');
        setOpen(true);
    };

    const handleModalClose = () => {
        setOpen(false);
        setSelectedCrown(null);
        setTempValue('');
    };

    const handleModalSave = async () => {
        if (selectedCrown && !updateLoading) {
            if (!tempValue || parseInt(tempValue, 10) <= 0) {
                toast.error("Please enter a value greater than 0");
                return;
            }
            const payload = {
                [selectedCrown.id]: parseInt(tempValue, 10) || 0
            };
            try {
                await dispatch(updateCrownPointsApi(payload)).unwrap();
                // AuthAxios already handles success toast
                dispatch(resetUpdateCrownPoints());
                dispatch(getCrownsListApi());
                handleModalClose();
            } catch (err) {
                // AuthAxios already handles error toast
                dispatch(resetUpdateCrownPoints());
            }
        }
    };

    const columns = [
        {
            field: 'name',
            headerName: 'Crown Name',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'points',
            headerName: 'Stars',
            flex: 1,
            sortable: false,
            filterable: false,
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.5,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Button
                    color="info"
                    endIcon={<EditIcon />}
                    variant="outlined"
                    sx={{ margin: "0px 10px" }}
                    onClick={() => handleEditClick(params.row)}
                >
                    EDIT
                </Button>
            ),
        }
    ];

    useEffect(() => {
        dispatch(getCrownsListApi());
    }, [dispatch]);

    return (
        <Box>
            <Paper elevation={1} sx={{ mt: 2 }}>
                <DataGridComponent
                    rows={crowns}
                    columns={columns}
                    getRowId={(row) => row.id}
                    pagination={false}
                    paginationMode="client"
                    filterMode="client"
                    sortingMode="client"
                    hideFooter
                    disableColumnFilter
                    disableColumnMenu
                    autoHeight
                    loading={loading}
                    sx={{
                        height: 'auto',
                        '& .MuiDataGrid-virtualScrollerContent': { minHeight: 'unset !important' },
                        '& .MuiDataGrid-cell': { py: '12px' },
                    }}
                    slots={{ toolbar: () => null }}
                />
            </Paper>

            <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
                {/* <Button variant="contained" onClick={handleSave} disabled={loading}>
                    Save
                </Button> */}
            </Stack>

            {/* Edit Modal */}
            <Dialog open={open} onClose={handleModalClose} fullWidth maxWidth="xs">
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6">Edit Crown: {selectedCrown?.name}</Typography>
                        <IconButton onClick={handleModalClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ py: 0.5 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Assign stars
                        </Typography>
                        <FormControl variant="outlined" fullWidth>
                            <OutlinedInput
                                type="text"
                                value={tempValue}
                                onChange={(e) => {
                                    setTempValue(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            // placeholder="0"
                            />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={handleModalClose} disabled={updateLoading}>Cancel</Button>
                    <Button variant="contained" onClick={handleModalSave} disabled={updateLoading}>
                        {updateLoading ? 'Saving...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
